<template>
    <div class="body" id="joinUp">
        <div class="head">
            <div class="head-title">学生综合素质评价</div>
            <div class="nowTime">{{nowTime}}</div>
        </div>
        <div class="box">
            <div class="box-l">
                <div class="box-lt box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="screen-title">成长活动</div>
                    <div class="activityNum">
                        <span class="orange">{{screenDatas.activityCount}}</span>次活动
                    </div>
                    <div id="myEcharts1" class="statics"></div>
                </div>
                <div class="box-lb box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="h100">
                        <div class="screen-title">活动风采</div>
                        <div class="carousel-box">
                            <el-carousel>
                                <el-carousel-item v-for="(item,index) in honorGallery" :key="index">
                                    <img :src="item.imgUrl">
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-c">
                <div class="box-ct">
                    <div class="box-ctt">
                        <div>
                            <div><span class="num">{{screenDatas.studentCount||0}}</span>名</div>
                            <div>我校学生数</div>
                        </div>
                        <div>
                            <div><span class="num">{{screenDatas.activityAvgCount||0}}</span>次</div>
                            <div>人均参与活动</div>
                        </div>
                        <div>
                            <div><span class="num">{{screenDatas.prizeAvgCnt||0}}</span>枚</div>
                            <div>人均获得奖章</div>
                        </div>
                        <div>
                            <div><span class="num">{{screenDatas.prize1AvgCnt||0}}</span>颗星</div>
                            <div>人均学分</div>
                        </div>
                    </div>
                    <div class="box-ctb">

                    </div>
                </div>
                <div class="box-cb box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="screen-title">优秀学生</div>
                    <div class="classes">
                        <el-select v-model="classId" placeholder="请选择班级" @change="classChange" clearable>
                            <el-option
                                    v-for="item in classes"
                                    :key="item.classId"
                                    :label="item.className"
                                    :value="item.classId">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="cb-box">
                        <div v-for="(item,index) in goodStudentsShow" :key="index" class="cb-student">
                            {{item.name}}
                            <span class="prizeNum">
                                <i class="el-icon-star-on yellow"></i>
                                x{{item.prizeValue}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-r">
                <div class="box-rt box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="screen-title">五育评价</div>
                    <div class="box-use">
                        <div class="use-l">
                            <div>评价方案 <span class="use-num">1</span> 个</div>
                            <div>评价人数 <span class="use-num">{{screenDatas.studentCount||0}}</span>个</div>
                            <div>人均评次数 <span class="use-num">{{screenDatas.activityAvgCount||0}}</span>次</div>
                        </div>
                        <div class="use-r">
                            <div>
                                <p>绿色评价等级评价</p>
                                <el-progress :show-text="false" :stroke-width="12" :percentage="90"
                                             define-back-color="#0F2335" color="#DED233"></el-progress>
                            </div>
                            <div>
                                <p>国家检测等级评价</p>
                                <el-progress :show-text="false" :stroke-width="12" :percentage="85"
                                             define-back-color="#0F2335" color="#27B198"></el-progress>
                            </div>
                            <div>
                                <p>学生互评</p>
                                <el-progress :show-text="false" :stroke-width="12" :percentage="80"
                                             define-back-color="#0F2335" color="#27B198"></el-progress>
                            </div>
                            <div>
                                <p>教师评价</p>
                                <el-progress :show-text="false" :stroke-width="12" :percentage="75"
                                             define-back-color="#0F2335" color="#27B198"></el-progress>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-rb box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="h100">
                        <div class="screen-title">奖章荣誉榜</div>
                        <div class="table">
                            <!--<div class="table-t">-->
                            <!--<div></div>-->
                            <!--<div></div>-->
                            <!--<div></div>-->
                            <!--</div>-->
                            <!--<div class="table-b">-->
                            <div v-for="(item,index) in rank4Student" :key="index" class="rb-table">
                                <p>{{item.name}}</p>
                                <p>{{item.className}}</p>
                                <p>{{item.prizeValue}}</p>
                            </div>
                        </div>
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "evaluateScreen",
        data() {
            return {
                query: {
                    schoolId: '',
                    openid: 'abc',
                    cPrizeId: 47,
                },
                realTime: [],
                screenDatas: {},
                myCharts1: null,
                nowTime: '',

                rank4Student: [],
                honorGallery: [],

                reverse: true,
                activities: [{
                    content: '评价方案',
                }, {
                    content: '评价人数',
                }, {
                    content: '人均评价次数',
                }],
                classes: [],
                classId: '',
                goodStudents: [],
                goodStudentsShow: [],
            }
        },
        created() {
            this.query.schoolId = this.$route.query.schoolId
            window.onresize = () => {
                this.myCharts1.resize();
            };
            this.nowTimes()
        },
        mounted() {
            this.funAll()
        },

        methods: {
            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
                let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
                let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
                let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
                let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
                this.nowTime = year + "-" + month + "-" + date + ' ' + hh + ":" + mm + ':' + ss

            },
            nowTimes() {
                this.timeFormate(new Date());
                setInterval(this.nowTimes, 1000);
                this.clear()
            },
            clear() {
                clearInterval(this.nowTimes)
                this.nowTimes = null;
            },
            funAll() {
                this.getPieChart(); //基本情况
            },
            // 基本情况
            getPieChart() {
                let url = "/zuhu1/api-dashboard/evaluateContentProcessFormData/dashboard"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data
                        this.screenDatas = datas || {}

                        let pieChart = datas.pieChart || []
                        let arr1 = []
                        pieChart.map(item => {
                            let obj = {
                                name: item.evaluateQuotaName,
                                value: item.pieChartCount
                            }
                            arr1.push(obj)
                        })
                        this.statistics(arr1)

                        let rank4Student = datas.rank4Student || []
                        this.rank4Student = rank4Student

                        let honorGallery = datas.honorGallery || []
                        let images = []
                        honorGallery.map(item => {
                            if (item.imgUrl.indexOf('jpg') != -1) {
                                images.push(item)
                            }
                        })
                        this.honorGallery = images
                        this.classes = datas.classes || []
                        this.goodStudents = datas.goodStudents || []
                        this.goodStudentsShow = this.goodStudents
                    }
                })
            },
            // 按类别分类
            statistics(datas) {
                this.myCharts1 = this.$echarts.init(document.getElementById('myEcharts1'))
                // 绘制图表
                this.myCharts1.setOption({
                    color: ['#3EECFD', '#4964F5', '#00E437', '#8BB2DE', '#ED5400', '#00A8FF', '#FDD100'],
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'horizontal',
                        bottom: 'bottom',
                        textStyle: {
                            color: '#fff',
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['30%', '45%'],
                            data: datas,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            textStyle: {
                                color: '#fff',
                                fontSize: 16,
                                fontWeight: 'bold',
                                labelPosition: 'outside'
                            },
                            label: {
                                show: true,
                                formatter: '{b}: {c}' // 显示名称和数值
                            }
                        }
                    ]
                })
            },

            classChange() {
                let classes = this.classes
                let className = ''
                classes.map(item => {
                    if (item.classId == this.classId) {
                        className = item.className
                    }
                })
                let arr = []
                this.goodStudents.map(item => {
                    if (item.className == className) {
                        arr.push(item)
                    }
                })
                this.goodStudentsShow = arr

                if(!this.classId){
                    this.goodStudentsShow = this.goodStudents
                }
            },

        }
    }
</script>

<style scoped>
    .body {
        width: 100%;
        /*height: 1080px;*/
        height: 100%;
        background: rgb(3, 17, 51);
        overflow: hidden;
        background: url("../../assets/imgs/smartLinkBigScreen/bg.jpg") no-repeat center 0;
    }

    .head {
        height: 120px;
        color: white;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 38px;
        position: relative;
        background: url("../../assets/imgs/smartLinkBigScreen/topbg.png") no-repeat center 0;
        box-sizing: border-box;
    }

    .head-title {
        background: -webkit-linear-gradient(#4AF3F3, #179DF5);
        -webkit-background-clip: text;
        color: transparent;
        font-weight: bold;
    }

    .box {
        display: flex;
        /*height: 960px;*/
        height: calc(100% - 100px);
        margin-top: -20px;
    }

    .box > div {
        padding: 10px 0 0;
    }

    .box > div > div {
        width: 90%;
        margin: 0 auto 20px;
    }

    .box-l, .box-r {
        width: 30%;
    }

    .box-c {
        flex: 1;
        padding: 30px 0 0 0 !important;
    }

    .box-c > div {
        width: 96% !important;
    }

    .screen-title {
        color: #F9FEFE !important;
        /*font-weight: bold;*/
        font-size: 20px;
        padding: 20px 30px 10px;
    }


    .box-lt {
        height: calc(95% - 400px);
        min-height: 180px;
        position: relative;
    }

    .activityNum {
        background: #103369;
        border: 1px solid #275F8A;
        text-align: center;
        color: white;
        display: inline-block;
        position: absolute;
        right: 25px;
        top: 16px;
        padding: 5px 15px;
    }

    .orange {
        color: #FF6E1C;
        padding: 0 10px;
    }

    .box-img img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .box-lb {
        height: 400px;
        position: relative;
    }

    .table-t {

    }

    .h100 {
        height: 100%;
        position: relative;
        z-index: 10;
    }

    .table {
        height: calc(100% - 70px);
        overflow: auto;
    }

    .table::-webkit-scrollbar {
        width: 4px;
    }

    .table::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        opacity: 0.2;
        background: rgba(120, 229, 250, 1);
    }

    .table::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(120, 229, 250, 0.6);
    }


    .rb-table {
        width: 92%;
        display: flex;
        color: white;
        background: #0E2D6D;
        margin: 2px auto;
    }

    .rb-table > p {
        flex: 1;
        text-align: center;
        height: 34px;
        line-height: 34px;
    }


    .statics {
        width: 100%;
        /*height: 150px*/
        height: calc(100% - 70px);
    }

    .box-ct {
        /*height: calc(60% - 20px);*/
        height: 450px;
        margin-bottom: 20px;
        /*border: 1px solid red;*/
        position: relative;
        color: white;
    }

    .box-ctt {
        display: flex;
        justify-content: space-between;
    }

    .box-ctt > div {
        background: #103369;
        border: 1px solid #275F8A;
        width: 23%;
        text-align: center;
        padding: 5px 0 10px;
    }

    .box-ctb{
        height: 368px;
        background: url("../../assets/imgs/fivebg.jpg");
        background-size: 100% 100%
    }


    .box-ct1 > div {
        flex: 1;
        position: relative;
    }

    .box-ct2 > div {
        flex: 1;
        border: 1px solid #1D5A98;
        text-align: center;
    }


    .box-cb {
        /*height: 35%;*/
        height: calc(100% - 480px);
        position: relative;
    }

    .box-rt {
        height: calc(55%);
        position: relative;
    }

    .box-rb {
        height: calc(40%);
        position: relative;
    }

    .box-use {
        position: relative;
        z-index: 10;
        height: calc(100% - 66px);
        color: white;
        display: flex;
    }

    .use-l {
        flex: 2;
        padding: 0 0 0 20px;
    }

    .use-l > div {
        margin: 20px 0;
    }

    .use-r {
        flex: 3;
        padding: 0 20px 0 10px;
        box-sizing: border-box;
    }

    .use-r p {
        padding: 8px 0;
    }


    .buildBtn img {
        position: relative !important;
        width: 10px;
        height: 10px;
        text-align: center;
    }

    .nowTime {
        color: #69E7EE;
        position: absolute;
        right: 20px;
        top: 14px;
        font-size: 26px;
        display: inline-block;
    }

    .carousel-box {
        height: calc(100% - 100px);
        width: 94%;
        margin: auto;
        overflow: hidden;
    }

    .num {
        font-size: 28px;
        color: #92EAE6;
        padding: 0 10px;
    }

    .use-num {
        font-size: 20px;
        color: #F4E36E;
        padding: 0 5px;
    }

    .classes {
        position: absolute;
        top: 16px;
        right: 20px;
    }

    .classes /deep/ .el-input__inner {
        background-color: transparent !important;
        color: #d9d9d9;
        height: 40px;
    }

    .cb-box {
        height: calc(100% - 70px);
        overflow: auto;
        position: relative;
        z-index: 10;
    }

    .cb-box::-webkit-scrollbar {
        width: 4px;
    }

    .cb-box::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        opacity: 0.2;
        background: rgba(120, 229, 250, 1);
    }

    .cb-box::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(120, 229, 250, 0.6);
    }

    .cb-student {
        background: #123684;
        color: #04C5D4;
        display: inline-block;
        border: 1px solid #4473D6;
        border-radius: 5px;
        width: 27%;
        text-align: center;
        margin: 10px 3%;
    }
    .prizeNum{
        padding-left: 10px;
    }
    .yellow{
        color: #FFA305;
        font-size: 20px;
    }
</style>

